module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-pennant-b62f0f62b1df6d920f86c3258cd40337.svg";